import React from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {RadioButton} from '@components/common/base/radiobutton'
import {CommonProps} from '@components/sticker/my-stickers/board-stickers/sticker-settings/sticker-settings-content'
import {TwSettingRow} from './containers'
import {DropdownWithUsers} from './dropdown-with-users'
import {useCommonHandlers} from './use-common-handlers'
import {checkAuthorByDefault} from './utils/check-author-by-default'
import {getDefaultStateArray} from './utils/get-default-state-array'

const emptyUsers: string[] = []
const author = ['author']

export const UserStickerSettingsContent = (props: CommonProps) => {
  const {state, sticker, setState} = props
  const {toggleHasDefaultState, onDefaultStateChanged} = useCommonHandlers(
    sticker,
    setState
  )

  const onAuthorClick = () => onDefaultStateChanged(author)
  const onDefineUserClick = () => onDefaultStateChanged(emptyUsers)

  const userIds = getDefaultStateArray(state.defaultState)
  const isAuthor = checkAuthorByDefault(userIds)
  const disabled = !state.hasDefaultState

  return (
    <TwSettingRow>
      <CheckboxNew
        className="py-8"
        value={state.hasDefaultState ?? false}
        onChange={toggleHasDefaultState}
        label={Lang.msg.myStickers.assignDefaultValue}
      />
      <RadioButton
        disabled={disabled}
        active={isAuthor}
        onClick={onAuthorClick}
        label={Lang.msg.myStickers.assignDefaultValueToAuthor}
        className="ml-24 py-8"
      />
      <RadioButton
        disabled={disabled}
        active={!isAuthor}
        onClick={onDefineUserClick}
        label={Lang.msg.myStickers.assignDefaultValueToUser}
        className="ml-24 py-8"
      />
      <DropdownWithUsers
        selectedUserIds={isAuthor ? [] : (userIds as DataObjectId[])}
        onDefaultStateChanged={onDefaultStateChanged}
        disabled={disabled || isAuthor}
        board={props.board}
        className="ml-44"
      />
    </TwSettingRow>
  )
}
